import { useLayoutEffect } from 'react';
import { trimEnd } from 'lodash';
import { useLocation } from 'react-router-dom';
import { paths } from 'routes/paths';
import { CREATE_CLASSNAME_PREFIX as APPLICATION_CREATE_CLASSNAME_PREFIX } from 'screens/Applications&WorkOrders/Applications/Components/Notification';
import { CREATE_CLASSNAME_PREFIX as WORK_ORDER_CREATE_CLASSNAME_PREFIX } from 'screens/Applications&WorkOrders/WorkOrders/Components/Notification';
import { closeNotification } from 'screens/Applications&WorkOrders/Components/Notification/genericNotification';

export type NotificationNavigationDestroyRule = {
  classNamePrefix: string;
  pathname: string;
};

const NOTIFICATIONS: NotificationNavigationDestroyRule[] = [
  {
    classNamePrefix: APPLICATION_CREATE_CLASSNAME_PREFIX,
    pathname: paths.applications
  },
  {
    classNamePrefix: WORK_ORDER_CREATE_CLASSNAME_PREFIX,
    pathname: paths.workOrders
  }
];

// Normalize pathname to remove trailing slashes
export function normalizePathname(pathname: string): string {
  const withoutTrailingSlashes = trimEnd(pathname, '/');
  return withoutTrailingSlashes === '' ? '/' : withoutTrailingSlashes;
}

const useDestroyNotificationOnNavigation = () => {
  const location = useLocation();
  const currentPath = normalizePathname(location.pathname);

  useLayoutEffect(() => {
    NOTIFICATIONS.forEach(notification => {
      if (currentPath !== normalizePathname(notification.pathname)) {
        closeNotification(notification.classNamePrefix);
      }
    });
  }, [currentPath]);
};

export default useDestroyNotificationOnNavigation;
